import { z } from 'zod';

import { AI_MODEL_TYPE_OPTIONS } from '../constants';

export const zodValidateLabelingSchema = z.object({
  documentType: z.enum(['delivery', 'invoice']).optional().prefault('delivery'),
  includeDocuments: z.boolean().optional().prefault(true),
  modelChoice: z.enum(AI_MODEL_TYPE_OPTIONS).optional().prefault('di'),
  projectName: z.string().min(1),
  setup: z
    .enum(['detailed', 'summary', 'natural'])
    .optional()
    .prefault('detailed'),
});
